import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { SERVER_ENDPOINT } from '../shared/websocket.token';

export interface StreamingEntry {
  id: string;
  teamName: string;
  carNumber: string;
  carDeviceNumber: string;
  rtmpUrl: string;
  rtmpStreamKey: string;
  eip: string;
  eipAllocationId: string;
  videoId: string;
  hlsPlaybackUrl: string;
  isLive: boolean;
}

export interface IUpdateResponse {
  message: string;
  settings: VbLxpAdminSettings;
}

export interface VbLxpAdminSettings {
  race?: {
    disableStream?: boolean;
  };
  notificationMessage?: string;
  streamingData?: StreamingEntry[];
}

@Injectable()
export class VbLxpAdminSettingsService {
  private readonly http = inject(HttpClient);

  constructor(@Inject(SERVER_ENDPOINT) private readonly serverEndpoint: string) {}

  getSettings(): Observable<VbLxpAdminSettings> {
    return this.http.get<VbLxpAdminSettings>(`${this.serverEndpoint}api/admin/settings`);
  }

  updateSettings(newSettings: Partial<VbLxpAdminSettings>): Observable<IUpdateResponse> {
    return this.http.post<IUpdateResponse>(
      `${this.serverEndpoint}api/admin/settings`,
      newSettings,
    );
  }

  resetProdData(): Observable<{ success: boolean; message: string }> {
    return this.http.post<{ success: boolean; message: string }>(
      `${this.serverEndpoint}api/admin/reset-prod-data`,
      {},
    );
  }
}
